import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getUserEvents } from 'actions/User';
import {
  startEditingEvent,
  startDuplicatingEvent,
  archiveEvent,
  searchUserEvents,
  clearUserEventsSearchResults
} from 'actions/Event';
import EventList from 'components/event/List';
import EventSearchInput from 'components/team/EventSearchInput';
import NoItems, { ContentType } from 'components/NoItems';
import { UPCOMING_EVENT_FILTERS } from 'constants/EventFilters';
import { onSearchTermChange, onCancelSearch } from 'utils/eventSearchHelper';
import { redirectToEventDash } from 'utils/redirectHelper';
import { DateFormats } from 'utils/teamHelper';

const UserEventList = ({
  user,
  events,
  getUserEvents,
  startEditingEvent,
  startDuplicatingEvent,
  archiveEvent,
  searchUserEvents,
  clearUserEventsSearchResults,
  userEventSearchResults,
  history,
  isEventLoading
}) => {
  useEffect(() => {
    if (user) {
      getUserEvents();
    }
  }, [getUserEvents, user]);

  const [searchTerm, setSearchTerm] = useState('');

  const onItemClick = redirectToEventDash.bind(null, history);

  const eventSearchNode = (
    <EventSearchInput
      dateFormat={DateFormats.MDY}
      onChange={onSearchTermChange.bind(
        null,
        setSearchTerm,
        searchUserEvents,
        clearUserEventsSearchResults,
        UPCOMING_EVENT_FILTERS
      )}
      onResultClick={onItemClick}
      onCancel={onCancelSearch.bind(
        null,
        setSearchTerm,
        clearUserEventsSearchResults
      )}
      value={searchTerm}
      results={userEventSearchResults}
    />
  );

  const noItemsNode = (
    <NoItems
      title="You don’t have any events!"
      subTitle="You either deserve a vacation or need to request an invite to an event."
      showArrow={false}
      isLoading={isEventLoading}
      type={ContentType.UpcomingEvent}
    />
  );

  return (
    <EventList
      eventSearchNode={eventSearchNode}
      onEditClick={startEditingEvent}
      onViewClick={event => {
        history.push(
          `/dash/team/${event.team._id}/event/${event._id}/dashboard`
        );
      }}
      onDuplicateClick={startDuplicatingEvent}
      onArchiveClick={archiveEvent}
      events={events}
      isLoading={isEventLoading}
      noItemsNode={user && user.teams.length ? null : noItemsNode}
    />
  );
};

export default withRouter(
  connect(
    ({ userEvents, user, userEventSearchResults, isEventLoading }) => {
      return {
        events: userEvents,
        user,
        userEventSearchResults,
        isEventLoading
      };
    },
    {
      getUserEvents,
      startEditingEvent,
      archiveEvent,
      startDuplicatingEvent,
      searchUserEvents,
      clearUserEventsSearchResults
    }
  )(UserEventList)
);
